import { ChatUIMessage } from '../model/ai.types';

const getTextPartContent = (message: ChatUIMessage) => {
  return message.parts.reduce((acc, part) => {
    if (part.type === 'text') {
      return acc + part.text;
    }
    return acc;
  }, '');
};

const getLastAssistantMessage = (messages: ChatUIMessage[]) => {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (message.role === 'assistant') {
      return { value: message, index: i };
    }
  }
  return undefined;
};

export const resetMessagesAfterStop = (messages: ChatUIMessage[]) => {
  const cloned = [...messages];
  const lastAssistantMessage = getLastAssistantMessage(cloned);
  if (lastAssistantMessage) {
    const hasContent = !!getTextPartContent(lastAssistantMessage.value);
    if (!hasContent) {
      const removedMessages = cloned.splice(lastAssistantMessage.index - 1, 2);
      return {
        messages: cloned,
        removed: removedMessages,
      };
    }
  }

  return {
    messages: cloned,
    removed: [],
  };
};
